<div *ngIf="student" class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <div class="bg-grey-lighter-color w-100 mb-3 p-2">
        <span class="fs-5 fw-bolder">Información de interés</span>
    </div>

    <div class="container-fluid p-0">

        <div class="w-100" *ngFor="let studentExtraInfo of student.extraInfos">

            <div class="row w-100" *ngIf="studentExtraInfo.extraInfoName !== 'observaciones'">

                <div class="col-12 col-lg-3" >
                    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
                        <span class="text-primary-color fw-bolder">{{studentExtraInfo.extraInfoDisplayName}}</span>
                        <input type="text" pInputText class="w-100" [ngModel]="getExtraInfoActive(studentExtraInfo)" readonly="true"/>
                    </div>
                </div>

                <div class="col-12 col-lg-8" *ngIf="studentExtraInfo.active">
                    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
                        <span class="text-primary-color fw-bolder">Observaciones</span>
                        <input type="text" pInputText class="w-100" [ngModel]="studentExtraInfo.observations" readonly="true"/>
                    </div>
                </div>

            </div>

            <div class="row w-100" *ngIf="studentExtraInfo.extraInfoName === 'observaciones'">

                <div class="col-12">
                    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
                        <span class="text-primary-color fw-bolder">Observaciones</span>
                        <input type="text" pInputText class="w-100" [ngModel]="studentExtraInfo.observations" readonly="true"/>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>
